<div class="govuk-width-container">
    <div class="row">
        <nav class="govuk-main-wrapper col-12 col-md-4 pt-0" aria-label="Side navigation">
            <p class="govuk-body h-100"><app-menu></app-menu></p>
        </nav>
        <main class="col-12 col-md-8" id="main-content" tabindex="-1">

            <h1 class="govuk-heading-xl">Frequently Asked Questions</h1>
            <app-custom-object-banner page="faqs"></app-custom-object-banner>
            <app-custom-object-accordion page="faqs"></app-custom-object-accordion>
    
        </main>
    </div>
</div>